import { render } from "./termsConditions.vue?vue&type=template&id=4a715263&scoped=true"
const script = {}

import "./termsConditions.vue?vue&type=style&index=0&id=4a715263&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a715263"]])

export default __exports__